import { FunctionComponent } from 'react';

interface AnchorNavOptionProps {
  activeOptionColor: string;
  greyFillColor: string;
}

const AnchorNavFirstOptionActive: FunctionComponent<AnchorNavOptionProps> = ({
  activeOptionColor,
  greyFillColor,
}) => {
  return (
    <svg
      width="15"
      height="258"
      viewBox="0 0 15 258"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="23" r="6" fill={activeOptionColor} />
      <rect x="5" y="46" width="2" height="166" fill={greyFillColor} />
      <circle cx="6" cy="235" r="6" fill={greyFillColor} />
    </svg>
  );
};

export default AnchorNavFirstOptionActive;
